import { useState } from 'react';
import { Avatar, Box, Button, DropdownMenu, Flex, Text, IconButton, Container, Badge, AlertDialog } from '@radix-ui/themes';
import { Link, useNavigate } from 'react-router-dom';
import { BellIcon, EnvelopeClosedIcon, PersonIcon, DotsVerticalIcon, MoonIcon, SunIcon } from '@radix-ui/react-icons';
import { useDispatch, useSelector } from 'react-redux';
import { clearUser } from '../../redux/slices/userSlice';
import Breadcrumbs from './Breadcrumbs';
import { useTheme } from 'next-themes';
import api from '../../api'
import { toast } from 'react-toastify'
import { updateUser } from '../../redux/slices/userSlice'
import { updateGuardian, } from '../../redux/slices/guardianSlice'
import { clearAccount, updateAccount } from '../../redux/slices/accountSlice'
import { updateStudentDetails, updateStudentPayment, clearStudentAccount } from '../../redux/slices/studentAccountSlice';
import { clearTeacherAccount } from '../../redux/slices/teacherAccountSlice';
import { clearSchoolAdminAccount } from '../../redux/slices/schoolAdminAccountSlice';
import NotificationsList from '../common/NotificationsList';
import { DateTime } from 'luxon';
import { SUBSCRIPTION_BASE_AMOUNT } from '../../utils/constants';
import { updateAccountDetails, updatePaymentDetails } from '../../redux/slices/accountSlice';
import UserAvatar from '../common/UserAvatar';
import paymentService from '../../services/paymentService'

import GuardianSwitchAccountDialog from '../guardian/GuardianSwitchAccountDialog'
const ConsoleHeader = () => {
  const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const { account, loading } = useSelector(state => ({
    account: state.account,
    loading: state.account.loading
  }));
  // const userAccount = useSelector((state) => state.user.account);

  const userAccount = useSelector((state) => {
    switch (user.details.role) {
      case 'student':
        return state.studentAccount;
      case 'teacher':
        return state.teacherAccount;
      case 'school':
        return state.schoolAdmin;
      case 'guardian':
        return state.guardianAccount;
      default:
        return null;
    }
  });

  // console.log('USER ACCOUNT >>>>>>>', userAccount)
  // const notifications = useSelector((state) => state.user.notifications);
  const { theme, setTheme } = useTheme();
  const [openSwitchAccount, setOpenSwitchAccount] = useState(false);

  // console.log('user>>>>>>>>>>>>>>>>>>>', user)
  // console.log('account:', account)
  // console.log('Useraccount:', userAccount)


  const handleLogout = async () => {
    // Clear any auth tokens from localStorage
    localStorage.removeItem('authToken');
    dispatch(clearUser());
    dispatch(clearAccount());
    dispatch(clearStudentAccount());
    dispatch(clearTeacherAccount());
    dispatch(clearSchoolAdminAccount());

    const guardianUserId = localStorage.getItem('guardianUserId');
    if (guardianUserId && user.details.role === 'student') {

      await loginGuardian(guardianUserId);
    } else {
      localStorage.removeItem('guardianUserId');
      dispatch(clearUser());
      navigate('/login');
    }
  };

  const activateTrial = async () => {
    //try for free button should only show for students
    //parents should have a different endpoint and function
    //for activating their childrens trials

    if (user.details.role != 'student') {
      return;
    }

    try {
      const response_data = await paymentService.activateTrial({ student_id: userAccount.details.id })
      // console.log('trial payment response', response_data);
      dispatch(updateStudentDetails(response_data.student));
      dispatch(updateStudentPayment(response_data.payment));

      dispatch(updatePaymentDetails(response.data.payment_details));
      dispatch(updateAccountDetails(response.data.student));

      toast.success("Trial activated successfully, enjoy your 2 weeks trial", { position: "bottom-right" });
    } catch (error) {
      console.log('Error activating trial', error)

      toast.error("An unexpected error occured , try again", { position: "bottom-right" });
    }
  }


  const loginGuardian = async (guardianUserId) => {
    try {
      const response = await api.post(`/login-with-id/${guardianUserId}`)
      const loginData = response.data
      localStorage.setItem('authToken', loginData.user.authToken)
      dispatch(updateUser(loginData.user));
      dispatch(updateAccount(loginData.account));
      dispatch(updateGuardian(loginData.account))
      navigate('/guardian')
    } catch (error) {
      // console.log('Error logging in guardian:', error);
      toast.error("An unexpected error occured , log in back again", {
        position: "bottom-right"
      })
    }
  }

  const handleTrial = async () => {
    // Calculate date 7 days from now using Luxon
    const endDate = DateTime.now().plus({ days: 14 });
    // Format as YYYY-MM-DD
    const formattedEndDate = endDate.toISODate();

    try {
      const response = await api.post('/trial-payment', {
        student_id: account?.details?.id,
        received_from_id: account.details.id,
        received_from_type: 'App\\Models\\Student',
        discount_code: '2WEEKSTRIAL',
        discount_amount: SUBSCRIPTION_BASE_AMOUNT,
        amount: SUBSCRIPTION_BASE_AMOUNT,
        end_date: formattedEndDate,
        type: 'free_trial'
      });

      dispatch(updatePaymentDetails(response.data.payment_details));

      dispatch(updateAccountDetails(response.data.student));

      toast.success("Enjoy your 2 weeks trial", { position: "bottom-right" });

    } catch (error) {
      console.error('Error activating trial:', error);
    }
  };

  return (
    <Flex
      justify="between"
      align="center"
      width="100%"
      px="4"
      py="2"
    >
      {/* User Actions */}
      <Flex gap="2" direction="row" justify={{ initial: 'between', md: 'start' }} align="center" width="100%">
        <Box mr="auto" px="4" className="hidden md:block">
          <Breadcrumbs />
        </Box>


        <Flex gap="4" align="center" justify={{ initial: 'between', sm: 'start' }}>
          {user.details.role == 'school' && userAccount.school.crest != '' && (
            <Avatar
              size="3"
              src={`${PUBLIC_URL}/storage/${userAccount.school.crest}`}
              fallback={<Avatar
                size="3"
                src={'/images/defaultCrest.png'}
              />}
              radius="full"
              style={{ marginRight: '-25px', zIndex: 1 }}
            />)
          }
          <UserAvatar
            size="3"
            user={user.details}
            fallback={user.details.firstname?.[0]}
            radius="full"
          />

          <Flex direction="column" align="start" mr="2">
            <Text size="3" weight="bold" mb="0" align="left">{user.details.firstname} {user.details.lastname}</Text>
            {/* <Text size="2" style={{ textAlign: 'left' }}>{user.details.role.charAt(0).toUpperCase() + user.details.role.slice(1)}</Text> */}
          </Flex>
        </Flex>
        <Flex gap="2" justify='end' align="center">
          {['student', 'guardian'].includes(user.details.role) && !userAccount?.details?.trial_started_at && (
            <Button variant="solid" radius="full" size="2" onClick={() => activateTrial()}>Try for free</Button>
          )
          }
          <NotificationsList />

          <Button variant="soft" onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}>
            {theme === 'light' ? <MoonIcon /> : <SunIcon />}
          </Button>
          <DropdownMenu.Root>
            <DropdownMenu.Trigger>
              <IconButton variant="soft" size="2">
                <DotsVerticalIcon width="16" height="16" />
              </IconButton>
            </DropdownMenu.Trigger>
            <DropdownMenu.Content>
              <DropdownMenu.Item className='cursor-pointer' onClick={() => navigate(`/${user.details.role}/profile`)}>Profile</DropdownMenu.Item>
              {/* <DropdownMenu.Item>Settings</DropdownMenu.Item> */}

              {user.details.role === 'guardian' && (
                <DropdownMenu.Item className='cursor-pointer' onClick={() => setOpenSwitchAccount(true)}>Switch Account</DropdownMenu.Item>
              )}

              <DropdownMenu.Separator />
              <DropdownMenu.Item onClick={handleLogout}>Logout</DropdownMenu.Item>
            </DropdownMenu.Content>
          </DropdownMenu.Root>

          {
            user.details.role === 'guardian' && (
              <GuardianSwitchAccountDialog open={openSwitchAccount} setOpen={setOpenSwitchAccount} />
            )
          }

        </Flex >
      </Flex >

    </Flex >
  );
};

export default ConsoleHeader;
